import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import Container from "../../../components/commonContainer/Container";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BottomTabButtons from "../../../components/pagination/BottomTabButtons";
import companyApiService from "../../services/companyApiService";
import AddShop from "./AddShop";
import DeleteDialog from "../../../components/delete/DeleteDialog";
import "../../../components/headers/addbutton.scss";

const Shops = () => {
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedShop, setSelectedShop] = useState<any>(null);
  const [deleteId, setDeleteId] = useState("");
  const [tableData, setTableData] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const fetchShops = useCallback(async (page: number) => {
    setLoading(true);
    try {
      const response = await companyApiService.getCompaniesWithDetails();
      setTableData(response.data || []);
      setCount(response.data?.length || 0);
    } catch (err) {
      console.error("Failed to fetch shops:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchShops(page);
  }, [fetchShops, page]);

  // Search functionality
  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const query = e.target.value;
      setSearchQuery(query);

      if (query.trim() === "") {
        setIsSearching(false);
        setSearchResults([]);
        setSearchLoading(false);
        return;
      }

      setIsSearching(true);
      setSearchLoading(true);

      // Filter from tableData
      const filtered = tableData.filter(
        (shop) =>
          shop.companyName.toLowerCase().includes(query.toLowerCase()) ||
          (shop.email &&
            shop.email.toLowerCase().includes(query.toLowerCase())) ||
          (shop.phone && shop.phone.includes(query)),
      );
      setSearchResults(filtered);
      setSearchLoading(false);
    },
    [tableData],
  );

  const clearSearch = useCallback(() => {
    setSearchQuery("");
    setIsSearching(false);
    setSearchResults([]);
  }, []);

  const PaginationChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const updateShopInTable = useCallback(
    (updated: any) => {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === updated.id ? { ...item, ...updated } : item,
        ),
      );

      if (isSearching) {
        setSearchResults((prev) =>
          prev.map((item) =>
            item.id === updated.id ? { ...item, ...updated } : item,
          ),
        );
      }
    },
    [isSearching],
  );

  const deleteConfirm = useCallback((id: string) => {
    setDeleteId(id);
    setDeleteOpen(true);
  }, []);

  const deleteShop = useCallback(() => {
    // companyApCompanyce
    //   .deleteBranch(deleteId)
    //   .then(() => {
    //     setDeleteOpen(false);
    //     setDeleteId("");
    //     fetchShops(page);
    //   })
    //   .catch((err) => {
    //     setDeleteOpen(false);
    //     setDeleteId("");
    //     console.error(err);
    //   });
  }, [deleteId, fetchShops, page]);

  const handleEditClick = useCallback((item: any) => {
    // setSelectedShop(item);
    // setOpen(true);
    console.log(item);

    navigatory(`/company/shops/${item.id}`);
  }, []);

  const navigatory = useCallback((path: string) => {
    window.location.href = path;
  }, []);

  // Determine which data to display
  const displayData = isSearching ? searchResults : tableData;
  const displayCount = isSearching ? searchResults.length : count;

  const tableRows = useMemo(
    () =>
      displayData?.map((shop, index) => (
        <tr key={`${shop.id}_${index}`}>
          <td>{isSearching ? index + 1 : index + 1 + 20 * (page - 1)}</td>
          <td>{shop?.companyName}</td>
          <td>{shop?.email || "N/A"}</td>
          <td>{shop?.phone || "N/A"}</td>
          <td>{shop?.address || "N/A"}</td>
          <td>
            <button onClick={() => handleEditClick(shop)} className="edit">
              <BorderColorIcon />
            </button>
            {/* <button onClick={() => deleteConfirm(shop.id)} className="edit">
              <DeleteIcon />
            </button> */}
          </td>
        </tr>
      )),
    [displayData, handleEditClick, deleteConfirm, page, isSearching],
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Container className="product">
      {/* Header with Title, Search, and Add Button */}
      <div className="addbutton">
        <h2>Shops</h2>

        <div className="search_input_container">
          <div className="form__group search_group">
            <div className="search_input_wrapper">
              <SearchIcon className="search_icon" />
              <input
                type="text"
                className="form__field"
                placeholder="Search companies by name, email, phone..."
                value={searchQuery}
                onChange={handleSearch}
                disabled={loading}
                style={{ paddingLeft: "44px" }}
              />
              {searchQuery && (
                <button className="clear_search_btn" onClick={clearSearch}>
                  <ClearIcon />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="action_buttons">
          <button className="add" onClick={() => setOpen(true)}>
            <AddIcon />
            Add Shop
          </button>
        </div>
      </div>

      {/* Search Results Info */}
      {isSearching && (
        <div className="search_results_info">
          <span className="results_count">{searchResults.length}</span>
          {searchResults.length === 1 ? " result" : " results"} found for "
          {searchQuery}"
        </div>
      )}

      {/* Table */}
      {displayData.length === 0 && isSearching ? (
        <div className="no_search_results">
          {searchLoading ? (
            <>
              <SearchIcon className="empty_icon" />
              <h3>Searching...</h3>
            </>
          ) : (
            <>
              <SearchIcon className="empty_icon" />
              <h3>No companies found</h3>
              <p>Try adjusting your search terms or browse all companies</p>
            </>
          )}
        </div>
      ) : (
        <>
          <table className="employees-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Company Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{tableRows}</tbody>
          </table>

          {/* Pagination - only show when not searching */}
          {!isSearching && (
            <BottomTabButtons rows={count} onPageChange={PaginationChange} />
          )}
        </>
      )}

      {/* Add or Edit Shop Modal */}
      <AddShop
        setopen={setOpen}
        open={open}
        shop={selectedShop}
        setShop={setSelectedShop}
        onSuccess={() => fetchShops(page)}
      />

      {/* Delete Confirmation */}
      <DeleteDialog
        onDelete={deleteShop}
        setopen={setDeleteOpen}
        open={deleteOpen}
      />
    </Container>
  );
};

export default Shops;
